import { Link as BaseLink } from '@exam-management/router';
import { ArrowBackRoundedIcon, Button, type ButtonProps } from '@shared/components';
import type { ComponentProps } from 'react';

type BaseLinkProps = ComponentProps<typeof BaseLink>;

export interface NavigateBackLinkProps {
  label?: string;
  sx?: ButtonProps['sx'];
  to: BaseLinkProps['to'];
  params?: BaseLinkProps['params'];
  replace?: BaseLinkProps['replace'];
}

export default function NavigateBackLink(props: Readonly<NavigateBackLinkProps>) {
  const { label = 'Back', to, sx, params } = props;

  return (
    // @ts-expect-error MUI's loading button does not support `component` prop
    <Button
      variant='text'
      startIcon={<ArrowBackRoundedIcon />}
      component={BaseLink}
      to={to}
      params={params}
      sx={{
        p: (theme) => theme.spacing(0),
        minWidth: 'auto',
        height: 'auto',
        ...sx,
      }}
    >
      {label}
    </Button>
  );
}
